// // import axios from 'axios'
// // import { useState } from 'react'
// // import { useNavigate } from 'react-router-dom';
// // import icono from '../../images/usuario.png'


// // export default function Login() {
// //     const navigate = useNavigate();

// //     const [nombre, setNombre] = useState('')
// //     const [clave, setClave] = useState('')
// //     const [errorMensaje, setErrorMensaje] = useState('')
// //     const [showPassword, setShowPassword] = useState(false);


// //     const handleNombreChange = (e) => {
// //         const nombreIngresado = e.target.value.trim()
// //         setNombre(nombreIngresado)
// //         setErrorMensaje('')
// //     }

// //     const handleClaveChange = (e) => {
// //         const claveIngresado = e.target.value.trim()
// //         setClave(claveIngresado)
// //         setErrorMensaje('')
// //     }

// //     const toggleShowPassword = () => {
// //         setShowPassword(!showPassword);
// //     }

// //     const handleLogin = async (e) => {

// //         if (!nombre || nombre.trim() === "") {
// //             setErrorMensaje('¡Ingrese Usuario!');
// //             return;
// //         }

// //         if (!clave || clave.trim() === "") {
// //             setErrorMensaje('¡Ingrese Contraseña!');
// //             return;
// //         }


// //         try {
// //             const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, { nombre, clave })

// //             if (response.status === 200) {
// //                 const { token } = response.data
// //                 localStorage.setItem('auth_usuario', token);
// //                 navigate('/layout');
// //             }

// //         } catch (error) {
// //             if (error.response && error.response.status === 401) {
// //                 setErrorMensaje(error.response.data.message);
// //             } else {
// //                 setErrorMensaje('Error al iniciar sesión.');
// //             }
// //         }
// //     }

// //     return (

// //         <div className="bg-white">
// //             <div className="flex justify-center h-screen w-screen items-center">
// //                 <div className="w-full md:w-1/2 flex flex-col items-center " >

// //                     <img src={icono} alt="usuario" className='w-20 h-20 mb-8' />

// //                     <div className="w-72 lg:w-96 mb-6">
// //                         <input
// //                             type="text"
// //                             autoComplete='off'
// //                             name="usuario"
// //                             id="usuario"
// //                             className="w-full py-4 px-8 bg-slate-200 placeholder:font-semibold rounded hover:ring-1 outline-blue-500"
// //                             placeholder="Usuario..."
// //                             onChange={handleNombreChange}
// //                         />
// //                     </div>

// //                     <div className="w-72 lg:w-96 mb-6 relative">
// //                         <input
// //                             type={showPassword ? "text" : "password"}
// //                             name="password"
// //                             id="password"
// //                             className="w-full py-4 px-8 bg-slate-200 placeholder:font-semibold rounded hover:ring-1 outline-blue-500 "
// //                             placeholder="Contraseña..."
// //                             onChange={handleClaveChange}
// //                         />

// //                         <button
// //                             type="button"
// //                             onClick={toggleShowPassword}
// //                             className="absolute right-4 top-4 "
// //                         >
// //                             {showPassword ? '👁' : '👁‍🗨'}
// //                         </button>

// //                     </div>

// //                     {errorMensaje && <p className="text-red-500 font-semibold text-center mb-2 -mt-2 -lg:mt-4">{errorMensaje}</p>}

// //                     <div className="w-72 lg:w-96 mt-4">
// //                         <button
// //                             type="submit"
// //                             className="py-4 bg-blue-500 w-full rounded text-blue-50 font-bold hover:bg-blue-700"
// //                             onClick={handleLogin}
// //                         >
// //                             INGRESAR
// //                         </button>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>


// //     )
// // }


// import axios from 'axios';
// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import icono from '../../images/usuario.png';

// export default function Login() {
//   const navigate = useNavigate();

//   const [nombre, setNombre] = useState('');
//   const [clave, setClave] = useState('');
//   const [errorMensaje, setErrorMensaje] = useState('');
//   const [showPassword, setShowPassword] = useState(false);

//   const handleNombreChange = (e) => {
//     setNombre(e.target.value);
//     setErrorMensaje('');
//   };

//   const handleClaveChange = (e) => {
//     setClave(e.target.value);
//     setErrorMensaje('');
//   };

//   const toggleShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleLogin = async () => {
//     if (!nombre.trim()) {
//       setErrorMensaje('Por favor, ingrese su nombre de usuario.');
//       return;
//     }

//     if (!clave.trim()) {
//       setErrorMensaje('Por favor, ingrese su contraseña.');
//       return;
//     }

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, { nombre, clave });

//       if (response.status === 200) {
//         const { token } = response.data;
//         localStorage.setItem('auth_usuario', token);
//         navigate('/layout');
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         setErrorMensaje(error.response.data.message || 'Credenciales incorrectas.');
//       } else {
//         setErrorMensaje('Ha ocurrido un error. Intente nuevamente.');
//       }
//     }
//   };

//   return (
//     <div className="bg-gradient-to-br from-slate-100 to-slate-300 min-h-screen flex items-center justify-center font-sans">
//       <div className="bg-white shadow-lg rounded-2xl px-10 py-12 w-full max-w-md">
//         <div className="flex justify-center mb-6">
//           <img src={icono} alt="usuario" className="w-20 h-20" />
//         </div>

//         <h2 className="text-center text-2xl font-bold text-gray-800 mb-6">Iniciar Sesión</h2>

//         {errorMensaje && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm">
//             {errorMensaje}
//           </div>
//         )}

//         <div className="mb-4">
//           <label htmlFor="usuario" className="block text-sm font-semibold text-gray-700 mb-1">Usuario</label>
//           <input
//             id="usuario"
//             type="text"
//             name="usuario"
//             value={nombre}
//             onChange={handleNombreChange}
//             placeholder="Ingrese su usuario"
//             className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
//           />
//         </div>

//         <div className="mb-4 relative">
//           <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-1">Contraseña</label>
//           <input
//             id="password"
//             type={showPassword ? 'text' : 'password'}
//             name="password"
//             value={clave}
//             onChange={handleClaveChange}
//             placeholder="Ingrese su contraseña"
//             className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
//           />
//           <button
//             type="button"
//             onClick={toggleShowPassword}
//             className="absolute right-3 top-9 text-sm text-blue-600 hover:text-blue-800"
//           >
//             {showPassword ? 'Ocultar' : 'Mostrar'}
//           </button>
//         </div>

//         <button
//           onClick={handleLogin}
//           className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-md transition duration-200"
//         >
//           Ingresar
//         </button>
//       </div>
//     </div>
//   );

// }


import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const logo = `${process.env.PUBLIC_URL}/logo.png`;

export default function Login() {
  const navigate = useNavigate();

  const [nombre, setNombre] = useState('');
  const [clave, setClave] = useState('');
  const [errorMensaje, setErrorMensaje] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleNombreChange = (e) => {
    setNombre(e.target.value);
    setErrorMensaje('');
  };

  const handleClaveChange = (e) => {
    setClave(e.target.value);
    setErrorMensaje('');
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    if (!nombre.trim()) {
      setErrorMensaje('Por favor, ingrese su usuario.');
      return;
    }

    if (!clave.trim()) {
      setErrorMensaje('Por favor, ingrese su contraseña.');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, { nombre, clave });

      if (response.status === 200) {
        const { token } = response.data;
        localStorage.setItem('auth_usuario', token);
        navigate('/layout');
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setErrorMensaje(error.response.data.message || 'Acceso denegado.');
      } else {
        setErrorMensaje('Error de conexión.');
      }
    }
  };

  return (
    <div className="min-h-[100dvh] bg-white dark:bg-slate-950 lg:grid lg:grid-cols-2">

      {/* Panel de marca (solo escritorio) */}
      <aside className="relative hidden overflow-hidden bg-gradient-to-br from-brand-400 via-brand-600 to-brand-800 text-white lg:flex lg:flex-col lg:justify-between lg:p-12 xl:p-16">
        <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-40 -left-24 h-[28rem] w-[28rem] rounded-full bg-white/5" />

        <div className="relative flex items-center gap-3">
          <img src={logo} alt="" className="h-11 w-11 rounded-xl bg-white/10 object-contain" />
          <div className="leading-tight">
            <p className="text-lg font-bold tracking-tight">Chaboux</p>
            <p className="text-sm text-brand-100">Cluster</p>
          </div>
        </div>

        <div className="relative max-w-md">
          <h2 className="text-4xl font-semibold leading-tight tracking-tight xl:text-5xl">
            Lista de precios siempre a mano.
          </h2>
          <p className="mt-4 text-lg text-brand-100">
            Bazar, Equipamiento Comercial y Gastronomía.
          </p>
        </div>

        <p className="relative text-sm text-brand-100/80">© 2026 Chaboux Cluster</p>
      </aside>

      {/* Formulario */}
      <main className="flex min-h-[100dvh] flex-col px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(2.5rem,env(safe-area-inset-top))] sm:px-10 lg:min-h-0">
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center">

          <div className="mb-8 flex flex-col items-center text-center lg:items-start lg:text-left">
            <img src={logo} alt="Chaboux Cluster" className="mb-6 h-20 w-20 object-contain lg:hidden" />
            <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white sm:text-3xl">Iniciar sesión</h1>
            <p className="mt-2 text-[15px] text-slate-500 dark:text-slate-400">Ingresá tus datos para acceder al catálogo.</p>
          </div>

          {errorMensaje && (
            <div
              role="alert"
              className="mb-5 flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700 animate-shake dark:border-red-900/60 dark:bg-red-950/50 dark:text-red-300"
            >
              <svg className="mt-0.5 h-4 w-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
              <span>{errorMensaje}</span>
            </div>
          )}

          <form
            className="space-y-5"
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            {/* Usuario */}
            <div>
              <label htmlFor="usuario" className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                Usuario
              </label>
              <div className="relative">
                <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5 text-slate-400">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.1a7.5 7.5 0 0115 0A17.9 17.9 0 0112 21.75c-2.68 0-5.22-.58-7.5-1.65z" />
                  </svg>
                </span>
                <input
                  id="usuario"
                  type="text"
                  value={nombre}
                  onChange={handleNombreChange}
                  placeholder="Tu usuario"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck="false"
                  className="h-12 w-full rounded-xl border border-slate-300 bg-white pl-11 pr-4 text-base text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/15 dark:border-slate-700 dark:bg-slate-900 dark:text-white dark:placeholder:text-slate-500 dark:focus:border-brand-400"
                />
              </div>
            </div>

            {/* Contraseña */}
            <div>
              <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300">
                Contraseña
              </label>
              <div className="relative">
                <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5 text-slate-400">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                  </svg>
                </span>
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={clave}
                  onChange={handleClaveChange}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  className="h-12 w-full rounded-xl border border-slate-300 bg-white pl-11 pr-12 text-base text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/15 dark:border-slate-700 dark:bg-slate-900 dark:text-white dark:placeholder:text-slate-500 dark:focus:border-brand-400"
                />
                <button
                  type="button"
                  onClick={toggleShowPassword}
                  aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  className="absolute inset-y-0 right-0 flex w-12 items-center justify-center rounded-r-xl text-slate-400 transition-colors hover:text-slate-600 focus:outline-none focus-visible:text-brand-600 dark:text-slate-500 dark:hover:text-slate-300"
                >
                  {showPassword ? (
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                  ) : (
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 014.125-4.713M9.75 9.75L14.25 14.25M5.625 5.625l12.75 12.75" /></svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="mt-2 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-brand-600 text-base font-semibold text-white shadow-sm shadow-brand-900/20 transition hover:bg-brand-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30 active:scale-[0.99]"
            >
              Ingresar
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </form>
        </div>

        <p className="mt-10 text-center text-xs text-slate-400 dark:text-slate-600 lg:hidden">© 2026 Chaboux Cluster</p>
      </main>
    </div>
  );
}
